import { Component, OnInit, Host } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { PortalService } from '../portal.service';

@Component({
  selector: 'tela-boleto',
  templateUrl: './tela-boleto.component.html',
  styleUrls: ['./tela-boleto.component.scss']
})
export class TelaBoletoComponent implements OnInit {

  public urlBoleto;

  constructor(private service: PortalService, private route: ActivatedRoute,
    private domSanitizer: DomSanitizer) { }

  ngOnInit() {

    let url = "https://app.unifar.com.br/crm/#/login-boleto/" + this.service.getNumeroDeSerie();

    this.urlBoleto = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-boleto/tela-boleto.component.ts